import React from 'react';
import styles from './TermsFooter.module.scss';
import * as CSS from 'csstype';

interface TermsFooterProps {
  position?: CSS.Property.Position,
  className?: string,
}

function TermsFooter({
  position = 'absolute',
  className = '',
}: TermsFooterProps) {
  const currentYear = new Date().getFullYear();
  
  return (
    <div
      className={styles.footer_terms + (className ? ` ${className}` : '')}
      style={{ position: position }}
    >
      <div className={styles.footer_content} role="contentinfo">
        © 1999 - {currentYear}{' '}
        <a
          href="https://www.w3schools.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{ paddingLeft: '5px' }}
        >
          W3Schools
        </a>
        . <span style={{ display: 'inline-block', padding: '0 5px' }}>All rights reserved.</span>{' '}
        <a
          href="https://www.w3schools.com/about/about_privacy.asp"
          target="_blank"
          rel="noopener noreferrer"
        >
          Cookie policy
        </a>
        ,{' '}
        <a
          href="https://www.w3schools.com/about/about_privacy.asp"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy
        </a>{' '}
        and{' '}
        <a
          href="https://www.w3schools.com/about/about_copyright.asp"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms
        </a>
        .
      </div>
    </div>
  );
}

export default TermsFooter;
